import ROUTES from 'constants/routes';
import { ErrorInfo, useState, ComponentType } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Link, Stack, Typography } from '@mui/material';

const withErrorBoundary = <T extends object>(Component: ComponentType<T>) => {
  // eslint-disable-next-line react/function-component-definition, react/display-name
  return (props: T) => {
    const [componentStack, setComponentStack] = useState<string | null>();

    const onError = (error: Error, info: ErrorInfo) => {
      setComponentStack(info.componentStack);
    };

    const errorBoundaryFallbackRender = ({ error }: FallbackProps) => {
      return (
        <Stack spacing={4} alignItems='center' sx={{ py: 5, px: 2, textAlign: 'center' }}>
          <Typography variant='h3'>Произошла непредвиденная ошибка</Typography>
          <Link href={ROUTES.ASSESSMENT}>На главную страницу</Link>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {error?.toString()}
            <br />
            {componentStack}
          </details>
        </Stack>
      );
    };

    return (
      <ErrorBoundary fallbackRender={errorBoundaryFallbackRender} onError={onError}>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
};

export default withErrorBoundary;
